import React, { useContext, useEffect, useState } from "react";
import LineChart from "../Chart/LineChart";
import Title from "../Title/Title";
import Table from "../Table/Table";
import overviewCards from "../Overview/OverviewCard/OverviewDummy";
import { FlinkContext } from "../../context/FlinkContext";
import Loading from "../Loading/Loading";
import Logger from "../../Helper/Logger";

function FlinkOil() {
  const oilData = useContext(FlinkContext);
  const [oil, setOil] = useState(null);
  useEffect(() => {
    setOil(oilData.oil);
  }, [oilData]);

  return (
    <div className="GrayBox">
      {oil ? (
        <div className="Flink-container Flink-Oil">
          <Title title="Oil" icon={overviewCards.oil.icon} />
          <div className="row">
            <Logger op="Chart" id="17153" className="col-md-6 col-sm-12">
              <LineChart
                yAxisTitle="$/bbl"
                data={oil.chart}
                colors={["#004474", "#70cff9"]}
                showLegend
              />
            </Logger>
            <Logger op="News" id="40113" className="col-md-6 col-sm-12">
              <Table
                date2={oil.oilTable.date2}
                date1={oil.oilTable.date1}
                firstThName="Oil"
                showBtn="none"
                data={oil.oilTable.pricesTable}
              />
            </Logger>
          </div>
        </div>
      ) : (
        <Loading />
      )}
    </div>
  );
}

export default FlinkOil;
